module.exports = __webpack_public_path__ + "img/WechatCode.a9936e94.jpeg";